
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Enum.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

export enum DnsRecordType {
	A = 0,
	AAAA = 1,
	CNAME = 2,
	MX = 3,
	TXT = 4,
	SRV = 5,
	NS = 6,
	CAA = 7,
	SSHFP = 8,
	TLSA = 9
}
export namespace DnsRecordType {
	export function getKeys(): Map<DnsRecordType, string> {
		return new Map([[0, 'A'], [1, 'AAAA'], [2, 'CNAME'], [3, 'MX'], [4, 'TXT'], [5, 'SRV'], [6, 'NS'], [7, 'CAA'], [8, 'SSHFP'], [9, 'TLSA']]);
	}
}
